import ko from "knockout";
import viewHtml from "./dropdownCustom.html";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import { selectLabel } from "flow/koHelpers/selectParam";
import { selectIdAttr } from "flow/koHelpers/selectId";
import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";

export interface IDropdownCustomParams {
    value: KnockoutObservable<any>;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    data: any;
    valueAllowUnset: boolean;
    attr?: MaybeObservableAttributes;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
}

ko.components.register("ko-dropdown-custom", {
    viewModel: function (params: IDropdownCustomParams) {
        this.value = params.value;

        this.required = createRequiredObservable(params.value);

        this.id = selectIdAttr("ko_dropdown_custom", params.attr);

        this.label = selectLabel(params.meta, params.text);

        this.enable = createEnabler(params.enable, params.disable);

        this.data = params.data;

        this.valueAllowUnset = params.valueAllowUnset ? params.valueAllowUnset : false;

        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off"
            },
            params.attr
        );
    },
    template: viewHtml,
    synchronous: true
});
